import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-3-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading font-bold text-xl text-white">韩漫大全</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-xs">
              韩漫大全漫画网 - 最全面的韩漫在线阅读平台。提供下拉式免费阅读，无删减完整版本，更新速度快，内容库庞大，为您带来极致的韩漫阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center cursor-pointer hover:border-primary-500 hover:text-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center cursor-pointer hover:border-primary-500 hover:text-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center cursor-pointer hover:border-primary-500 hover:text-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center cursor-pointer hover:border-primary-500 hover:text-primary-500 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <Link to="/category/romance" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">分类浏览</Link>
                <Link to="/category/fantasy" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">热门排行</Link>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link>
              </div>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-4">热门分类</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/romance" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">恋爱漫画</Link>
                <Link to="/category/fantasy" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">奇幻漫画</Link>
                <Link to="/category/action" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">热血漫画</Link>
                <Link to="/category/thriller" className="text-sm text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer">悬疑漫画</Link>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-4">联系我们</h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-300">
              <div className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-500"></i>
                <span>hello@uhomekj.com</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-500"></i>
                <span>上海市浦东新区张江高科技园区</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-primary-500"></i>
                <span>400-888-9999</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫大全漫画网 版权所有 | 沪ICP备2024000000号
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}